import Cookies from 'js-cookie';
import Mark from 'mark.js';
export default {
    init() {
        let acc = document.getElementsByClassName("accordion");
        let i;
        let that = this;

        console.log("Accordions are being initiated.");

        for (i = 0; i < acc.length; i++) {
            // acc[i].removeEventListener('click', () => {});
            // acc[i].addEventListener("click", function() {
            var accordion = acc[i];
            that.timpson_response(accordion.nextElementSibling);

            // $(acc[i]).click((e) => {
            // acc[i].addEventListener('click', function fn() {
            $(accordion).off('click');
            $(accordion).on('click', function() {
                console.log("CLICKED")
                let children = this.children;
            
                if(this.classList.contains('accordion--border')) {
                    console.log('Removing border');
                    this.classList.remove('accordion--border');
                    let chevron = this.getElementsByClassName('accordion__chevron')[0];
                    if(chevron) {
                        chevron.classList.remove('accordion__chevron--down')
                        chevron.classList.add('accordion__chevron--up')
                    } else {
                        let chev_up = this.querySelector('.chev-up');
                        let chev_down = this.querySelector('.chev-down');
                        if(chev_up && chev_down) {
                            chev_up.classList.remove('hidden');
                            chev_down.classList.add('hidden')
                        }
                    }

                    let timpson_circle = this.querySelector('.timpson-circle');
                    if(timpson_circle) {
                        timpson_circle.classList.add('hidden');
                    }
                } else {
                    console.log('Adding border');
                    this.classList.add('accordion--border');
                    let chevron = this.getElementsByClassName('accordion__chevron')[0];
                    if(chevron) {
                        chevron.classList.add('accordion__chevron--down')
                        chevron.classList.remove('accordion__chevron--up')
                    } else {
                        let chev_up = this.querySelector('.chev-up');
                        let chev_down = this.querySelector('.chev-down');
                        if(chev_up && chev_down) {
                            chev_up.classList.add('hidden');
                            chev_down.classList.remove('hidden')
                        }
                    }

                    let timpson_circle = this.querySelector('.timpson-circle');
                    if(timpson_circle) {
                        timpson_circle.classList.remove('hidden');
                    }
                }
                
                /* Toggle between hiding and showing the active panel */
                let content = this.nextElementSibling;

                // console.log("Sibling: ", this);
                if (content.style.display === "block") {
                    content.style.display = "none";
                } else {
                    content.style.display = "block";
                }
            });

            if(Cookies.get('searchId')) {
                let searchId = Cookies.get('searchId');
                let searchTerm = Cookies.get('searchTerm') ?? null;
                if(searchId == accordion.dataset.id) {
                    accordion.click();
                    const y = accordion.getBoundingClientRect().top + window.pageYOffset + -150;
                    window.scrollTo({top: y, behavior: 'smooth'});
                    // accordion.scrollIntoView({behavior: 'smooth', block: 'start'})
                    if(searchTerm) {
                        let titleInstance = new Mark(accordion);
                        titleInstance.mark(searchTerm);
                        let contentInstance = new Mark(accordion.nextElementSibling);
                        contentInstance.mark(searchTerm);
                    }
                }

                Cookies.remove('searchTerm')
                Cookies.remove('searchPostType');
                Cookies.remove('searchId');
            }
        }
    },
    timpson_response(el) {
        let response_el = el.querySelector(".timpson-response");
        if(response_el) {
            let response = response_el.value;

            //if we contain any h5 elements add the response class to this.
            let headers = el.getElementsByTagName("h5");
            if(headers.length > 0) {
                for(let i = 0; i < headers.length; i++) {
                    headers[i].className = response
                }
            }
        }
    }
}